import rmskincareAPI from '../utils/rmskincareAPI';
import { AccountData } from '../data/AccountData';
import { registerObject } from '../data/registerObject';
const authApi = {
  login: async (username, password) => {
    let loginData = AccountData.newLoginData(username, password)
    let result = await rmskincareAPI.post('login', loginData);
    return result
  },

  logout: async (username, password) => {
    return await rmskincareAPI.get('logout');
  },

  refreshToken: async () => {
    let result = await rmskincareAPI.get('refresh');
    return result
  },

  create: async (name, email, password, id) => {
    let reigsterInfo = registerObject(name, email, password, id);
    let result = await rmskincareAPI.post(`account/create/${id}`, reigsterInfo);
    // console.log("res: ", result)
    return result;
  }

}

export default authApi
